import { render, staticRenderFns } from "./HeroSimple.vue?vue&type=template&id=6dd7b2f1&"
import script from "./HeroSimple.vue?vue&type=script&lang=js&"
export * from "./HeroSimple.vue?vue&type=script&lang=js&"
import style0 from "./HeroSimple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports